export const environment = {
    production: false,
    clientID: 'qURi6CKB3tnqtHtmuFvMBz19ELUvlatQ',
    domain: 'dev-ckmqie8d.eu.auth0.com',
    audience: 'https://dark-forest.trade/api',
    baseUrl: 'https://manager.dev.peanut.trade/api/',
    showNavMenu: true,
};
